import { inject, observer } from 'mobx-react';
import React from 'react'
import SlideItem from '../../Buttons/SlideItem';
import TextStyle from '../../Buttons/TextStyle';

@inject('textStore', 'sidebarStore', 'workAreaStore') @observer
class TextSlide extends React.Component {

  getTemplateContent(element){
    const { elements, italic, underline, groupId, content, size, colors, font, weight } = element
    if(font && font.id !== 'arial'){
      this.props.workAreaStore.appendFont(font)
    }
    let addStyles = {}
    if(italic){
      addStyles.fontStyle = 'italic'
    }
    if(underline){
      addStyles.textDecoration = 'underline'
    }
    if(groupId && elements){
      return (
        <div className='sidebar-slide__text-element-mixed'>
          {
            elements.map((el, idx) => {
              let addStyles = {}
              if(el.extraStyle){
                addStyles = { ...el.extraStyle }
              }
              if(el.italic){
                addStyles.fontStyle = 'italic'
              }
              if(el.underline){
                addStyles.textDecoration = 'underline'
              }
              if(el.font.id !== 'arial'){
                this.props.workAreaStore.appendFont(el.font)
              }
              return (
                <span key={idx}
                  className="sidebar-slide__text-element-mixed__content-mixed"
                  style={{
                    textAlign: el.textAlign,
                    fontFamily: el.font.value,
                    fontWeight: el.weight,
                    fontSize: el.size,
                    color: el.colors[0].color,
                    width: '100%',
                    ...addStyles
                  }}
                >{el.content}</span>
              )
            })
          }
        </div>
      )
    }
    return (
      <div className="sidebar-slide__text-element">
        <span 
          className="sidebar-slide__text-element__content"
          style={{
            fontFamily: font.value,
            weight: weight,
            fontSize: size,
            color: colors[0].color,
            ...addStyles
          }}
        >{content}</span>
      </div>
    )
  }

  handleClick(e, textElement){
    if(e.detail > 1){
      return
    }
    if(textElement.groupId && textElement.elements){
      this.props.workAreaStore.insertTextToPage(textElement)
      return
    }
    if(!this.props.workAreaStore.selectedLayer){
      this.props.sidebarStore.closeSidebarSlide()
      this.props.workAreaStore.setFontFamily('')
    }
    this.props.workAreaStore.insertTextToPage(textElement)
  }

  selectItem(item, e){
    const { sidebarStore } = this.props
    sidebarStore.setSelectedItem({...item, type: 'text'}, 'text', e)
  }

  render(){
    const { basicElements } = this.props.textStore
    const textElems = this.props.textStore.getTextTemplates()
    return(
      <div className="slide-wrapper">
        <div className="row no-gutters mb-4 mt-1">
          {
            basicElements.map(el => (
              <TextStyle 
                key={el.id} 
                {...el} 
                handleClick={(e) => this.handleClick(e, el)}
                onMouseDown={e => this.selectItem(el, e)}
              />
            ))
          }
        </div>
        <div className="row no-gutters text-template-row">
          <div className='col-xs-12 w-100 mb-2'>
            <h5>Text templates</h5>
          </div>
          {
            textElems.map((element, idx) => (
              <SlideItem 
                style={{
                  margin: '5px',
                  boxShadow: 'none',
                  padding: 0,
                }}
                key={element.id + String(idx)} 
                item={{ id:element.id, content: this.getTemplateContent(element) }} 
                clickAction={(e) => this.handleClick(e, element)} 
                onMouseDown={e => this.selectItem(element, e)}
              />
            ))
          }
        </div>
      </div>
    )
  }

}

export default TextSlide